/**
 * Firebase Configuration
 * 
 * Initializes Firebase Realtime Database for the application.
 * Used for storing device tracking data and contact form submissions.
 * 
 * SETUP INSTRUCTIONS:
 * 1. Create .env.local file in project root
 * 2. Add Firebase credentials (see .env.example)
 * 3. Get credentials from: Firebase Console > Project Settings > General > Your apps > Web app
 * 
 * REQUIRED ENVIRONMENT VARIABLES:
 * - REACT_APP_FIREBASE_API_KEY
 * - REACT_APP_FIREBASE_AUTH_DOMAIN
 * - REACT_APP_FIREBASE_DATABASE_URL (Realtime Database URL)
 * - REACT_APP_FIREBASE_PROJECT_ID
 * - REACT_APP_FIREBASE_STORAGE_BUCKET
 * - REACT_APP_FIREBASE_MESSAGING_SENDER_ID
 * - REACT_APP_FIREBASE_APP_ID
 * 
 * See docs/FIREBASE_SETUP.md for complete setup guide.
 */

import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Firebase configuration object
// All values are loaded from environment variables for security
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
let app;
let database;

try {
  app = initializeApp(firebaseConfig);
  database = getDatabase(app);
} catch (error) {
  /* eslint-disable no-console */
  console.error('❌ Firebase initialization error:', error);
  console.error('   Make sure .env.local file exists with all REACT_APP_FIREBASE_* variables');
  /* eslint-enable no-console */
}

export { app, database };
export default database;
